import {
  FieldHandler,
  FieldHandlerValidator,
  FieldSchema,
} from './auxiliary-data-table/auxiliary-data-table.interface';
import {
  CurrencyFieldHandler,
  DateFieldHandler,
  DropdownFieldHandler,
  IntegerFieldHandler,
  TextFieldHandler,
} from './renderers';
import { NotYetSupportedHandler } from './renderers/not-yet-supported';

export function chooseHandler(
  fieldId: string,
  fieldSchema: FieldSchema,
  fieldData: any,
  showLabel: boolean,
  validators: FieldHandlerValidator[] = [],
  readOnly = false,
): FieldHandler {
  const type = fieldSchema?.format || fieldSchema?.type;
  const label = showLabel ? fieldSchema?.title : '';
  switch (type) {
    case 'string':
    case 'email':
      return new TextFieldHandler(
        fieldId,
        fieldSchema?.title,
        label,
        fieldData,
        fieldSchema?.description,
        validators,
        readOnly,
      );
    case 'integer':
      return new IntegerFieldHandler(
        fieldId,
        fieldSchema.title,
        label,
        fieldData as number,
        fieldSchema.description,
        validators,
        readOnly,
      );
    case 'date':
      return new DateFieldHandler(
        fieldId,
        fieldSchema.title,
        label,
        fieldData,
        fieldSchema.description,
        validators,
        readOnly,
      );
    case 'dropdown':
      return new DropdownFieldHandler(
        fieldId,
        fieldSchema.title,
        label,
        fieldData,
        fieldSchema.dropdownOptions,
        validators,
        readOnly,
      );
    case 'currency':
      return new CurrencyFieldHandler(
        fieldId,
        fieldSchema.title,
        label,
        fieldData,
        fieldSchema.currencyCode,
        validators,
        readOnly,
      );
    case 'boolean':
      return new DropdownFieldHandler(
        fieldId,
        fieldSchema.title,
        label,
        fieldData,
        fieldSchema.dropdownOptions,
        validators,
        readOnly,
      );
    case 'phone':
    case 'stringList':
    case 'datetime':
    case 'geopoint':
    case 'float':
    default:
      console.warn(`Could not handle type ${type}`);
      return new NotYetSupportedHandler();
  }
}
